import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { WindowService } from '@core/window-actions';
import { Subscription } from 'rxjs';

import { PromoCodeResponse } from './promo-code.type';

@Component({
  selector: 'jb-promo-code-v2',
  templateUrl: './promo-code-v2.component.html',
  styleUrls: ['./promo-code-v2.component.scss'],
})
export class PromoCodeV2Component implements OnInit, OnDestroy {
  @Input() promoCodeData: PromoCodeResponse;
  @Input() promoCode: string;
  @Input() formControl: AbstractControl;
  @Output() promoCodeChange: EventEmitter<undefined> = new EventEmitter();
  @ViewChild('promoCodeInput') promoCodeInput: ElementRef;
  isMobile: boolean;
  activeFieldFocus = false;
  private subscriptions: Subscription = new Subscription();

  constructor(private windowService: WindowService) {
    this.subscriptions.add(
      this.windowService.isMobile.subscribe(mobile => {
        this.isMobile = mobile;
      }),
    );
  }

  ngOnInit() {
    this.formControl.setValue(this.promoCode || '');
  }
  onFocus() {
    this.activeFieldFocus = true;
  }
  onBlur() {
    this.activeFieldFocus = false;
  }

  focusOnInput() {
    this.promoCodeInput.nativeElement.focus();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
